
import * as defaultImport from "@splunk/react-ui/ControlGroup";
export * from "@splunk/react-ui/ControlGroup";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
